import React from 'react';
import './Create.css'; // Import the CSS file for styles

const Create = () => {
    return (
        <div className="projects-container">
            {/* Guide to Creating a Project */}
            <div className="create-project-section">
                <h3 className="section-title">How to Create a Project?</h3>
                <ul className="steps-list">
                    <li>
                        <strong>Step-1: Navigate to the Projects Section</strong>
                        <p>
                            Open the "Sheets" module and select the "Projects" section from the left-hand menu. 
                            This section contains a list of all existing projects along with the option to create new ones.
                        </p>
                        <img src="path-to-step1-image.png" alt="Navigate to Projects" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-2: Click on the "Add" Button</strong>
                        <p>
                            In the Projects section, click the "Add" button at the top-right corner to create a new project.
                            A form will appear where you need to enter essential details.
                        </p>
                        <img src="path-to-step2-image.png" alt="Click Add Button" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-3: Fill in the Basic Project Details</strong>
                        <p>
                            Enter the "Project Name", select the "Pay Type", and choose an "Employee Name" from the dropdown.
                            Once the employee is selected, the system will auto-fill their details such as email and phone number.
                        </p>
                        <img src="path-to-step3-image.png" alt="Fill Project Details" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-4: Select the Client and End Client</strong>
                        <p>
                            Choose the "Client" for the project. The system will automatically fetch and display the "End Client"
                            based on the client selection.
                        </p>
                        <img src="path-to-step4-image.png" alt="Select Client" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-5: Assign an Approval Manager</strong>
                        <p>
                            Click on the "Approval Manager" field and select the person responsible for managing the project.
                            This manager will have access to oversee project activities and approvals.
                        </p>
                        <img src="path-to-step5-image.png" alt="Assign Approval Manager" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-6: Set the Project Duration</strong>
                        <p>
                            Select the "Start Date" of the project. If the project has already begun, you can enter a previous date.
                            Then, set the "End Date" for the project. The end date remains editable in case the project is extended.
                        </p>
                        <img src="path-to-step6-image.png" alt="Set Project Duration" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-7: Confirm and Save the Project</strong>
                        <p>
                            Review all entered details, ensuring everything is correct. Once satisfied, click on the "Save" button
                            to successfully create the project.
                        </p>
                        <img src="path-to-step7-image.png" alt="Confirm and Save" className="step-image" />
                    </li>
                </ul>

                <p className="description">
                    <strong>Notes:</strong>
                    <ul>
                        <li>If the project has already started, you can enter a previous date, but once the project is saved, you can’t edit the start date. The end date is editable.</li>
                        <li>If you need to change the project end date, it is editable for long-term, unknown, or updated date changes in status.</li>
                    </ul>
                </p>
            </div>
        </div>
    );
};

export default Create;
